import Vue from 'vue'
import VueRouter from 'vue-router'
import fristerRouter from './fristerRouter'
import nProgress from 'nprogress'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'root',
        component: () => import(/* webpackChunkName: "about" */ '../views/Layout.vue'),
        redirect: '/group/h4402',
        children: []
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: () => import("@/views/Login.vue")
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
    nProgress.start()
    
    let title = to.meta?.title
    let titleArr = to.meta?.titleArr
    if(titleArr && titleArr.length == 1){
        title = titleArr[0]
    }
    title = title ? title + ' | 德行天下智慧数字运维系统' : '德行天下智慧数字运维系统'
    document.title = title
    
    if (to.path.includes('login')) {
        next()
    } else {
        const user = localStorage.getItem("user")
        if (user) {
            if (router.getRoutes().length == 2) {
                fristerRouter.change(router)
            }
            next()
        } else {
            next("/login")
        }
    }
})

router.afterEach(() => {
    nProgress.done()
})

export default router
